import React from "react";

const TabPane = ({ children }) => {
    return <div>{children}</div>;
};

export default TabPane;
